import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import FetchingSelect from '@/components/FetchingSelect';
import { UpsertRouteAchievementType } from '@/models/achievement.model';
import { getRoutesLookup } from '@/services/route.service';

const modelSchema = Schema.Model<UpsertRouteAchievementType>({
  routeId: Schema.Types.NumberType().isRequired('This field is required.'),
});
const emptyModel: UpsertRouteAchievementType = {
  routeId: undefined,
};
export interface RouteAchievementInitValue {
  routeId?: number,
  routeDistanceId?: number,
};

interface RouteVisitFormProps{
  formObject?: UpsertRouteAchievementType;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
  initValue?: RouteAchievementInitValue;
}

const RouteForm: React.FC<RouteVisitFormProps> = ({ formObject, onFormChange, formRef, loading, initValue }) => {
  const [formValue, setFormValue] = useState<UpsertRouteAchievementType>(emptyModel);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
    } else {
      setFormValue({...emptyModel, routeId: initValue?.routeId});
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-first-country' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:6}}>
            <Form.Group controlId="routeId">
              <Form.Label>Route</Form.Label>
              <Form.Control name="routeId" accepter={FetchingSelect} block
                fetchData={(text, page) => getRoutesLookup(text, page)} 
                placeholder="Select a route"
                value={formValue.routeId}
                onChange={val=> setFormValue(pre => ({...pre, routeId: val}))}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            ...
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default RouteForm;